var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"uk-scrollspy":"cls: uk-animation-slide-bottom-small; target: .animate; delay: 200; repeat: false"}},[_c('Chart'),_c('Booking'),_c('div',{staticClass:"row"},[_c('Customer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }